






























import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'
import SyncIndicator from '@components/SyncIndicator'
import AudienceListingDetail from '@ui/AudienceListing/AudienceListingDetail'
import MiniCalendar from '@ui/Calendar/MiniCalendar'

settings =
  name: 'AudienceAvailabilityShow'

  resources:
    audience_availability:
      resourceName: 'audience_availability'
      slug: 'audience_availabilities/:audienceAvailabilityId'

  components: {
    LoadingIndicator,
    SyncIndicator,
    AudienceListingDetail,
    MiniCalendar,
  }

  vue:
    computed:
      member: -> @$store.member
      supplierId: -> @member.supplier.id
      audienceAvailabilityId: -> @$route.params.audienceAvailabilityId

      listing: ->
        @audience_availability?.audience_listing

      displaySyncIndicator: ->
        @audience_availability?.marked_for_sync || @audience_availability?.marked_as_syncing

      optionsForCalendar: ->
        selectable: false
        dayCellClassNames: @dayCellClassNames

    methods:
      hiClose: -> @$router.back()

      dayCellClassNames: ({ date, isPast, ...args }) ->
        ['disabled']

      syncListing: ->
        return unless @audienceAvailabilityId
        if @listing.marked_for_sync || @listing.marked_as_syncing
          @triggerResource 'audience_availability', 'sync'

    watch:
      listing: (value) ->
        @syncListing() if value

export default VueOptions.vue settings
